export default __webpack_public_path__ + "static/media/responsibility9.7188bb23.png";